import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemAgitation } from '../components/ProblemAgitation';
import { ProductReveal } from '../components/ProductReveal';
import { ContentAndPricing } from '../components/ContentAndPricing';
import { FAQSection } from '../components/FAQSection';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-[#FAFAF7] selection:bg-[#C9A84C] selection:text-[#1B2A4A]" data-id="element-205">
      <HeroSection data-id="element-206" />
      <ProblemAgitation data-id="element-207" />
      <ProductReveal data-id="element-208" />
      <ContentAndPricing data-id="element-209" />
      <FAQSection data-id="element-210" />
    </main>;
}